import { lazy, Suspense } from 'react';
import LazyLoading from '../../components/LazyLoading';

const LazyGiftCardRedeem = lazy(
  () => import(/* webpackChunkName: 'GiftCardRedeem' */ './Redeem'),
);

export default function GiftCardRedeem() {
  return (
    <Suspense fallback={<LazyLoading />}>
      <LazyGiftCardRedeem />
    </Suspense>
  );
}
